import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';

import styles from './Filters.module.scss';
import { IFiltersProps } from './IFiltersProps';
import AddLeadingBrand from '../add/AddLeadingBrand';
import { MultiSelect, MultiSelectChangeParams } from 'primereact/multiselect';
import { useCookies } from 'react-cookie';

const Filters = ({
  divisionsOptions,
  countriesOptions,
  setBrandCodeFilter,
  setBrandDescriptionFilter,
  divisionFilter,
  setDivisionFilter,
  countryFilter,
  setCountryFilter,
  setShouldReload,
  productCategoriesOptions,
  selectedProductCategories,
  setSelectedProductCategories
}: IFiltersProps): JSX.Element => {
  const [cookies, setCookie] = useCookies([
    'leadingBrandsDivision',
    'leadingBrandsCountry',
    'leadingBrandsProductCategories',
  ]); 
  
  return (
    <div className={styles.container}>
      <InputText
        className={styles.filter}
        placeholder="Brand code"
        onChange={e => {
          setBrandCodeFilter(e.target.value);
        }}
      />
      <InputText
        className={styles.filter}
        placeholder="Brand description"
        onChange={e => {
          setBrandDescriptionFilter(e.target.value);
        }}
      />
      <Dropdown
        style={{ width: '10%' }}
        className={styles.filter}
        placeholder="Division"
        value={divisionFilter}
        options={divisionsOptions}
        onChange={(e: DropdownChangeParams) => {
          setDivisionFilter(e.target.value);
          setCookie("leadingBrandsDivision", e.value);
        }}
      />
      <Dropdown
        filter
        style={{ width: '24%' }}
        className={styles.filter}
        placeholder="Country"
        value={countryFilter}
        options={countriesOptions}
        onChange={(e: DropdownChangeParams) => {
          setCountryFilter(e.target.value);
          setCookie("leadingBrandsCountry", e.value);
        }}
      />
      <MultiSelect
        className={`${styles.filter} ${styles.categoryFilter}`}
        value={selectedProductCategories}
        options={productCategoriesOptions}
        onChange={(e: MultiSelectChangeParams) => {
          setSelectedProductCategories(e.value);
          setCookie("leadingBrandsProductCategories", e.target.value);
        }}
        placeholder="Product category"
        filter
      />

      <AddLeadingBrand
        divisionsOptions={divisionsOptions}
        countriesOptions={countriesOptions}
        setShouldReload={setShouldReload}
      />
    </div>
  );
};

export default Filters;
